import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ModalActivate = styled.button<Props>`
  background: ${(props) =>
    props.focused
      ? `linear-gradient(
          0deg,
          ${Colors['modal']['button']['border']},
          ${Colors['modal']['button']['gradient']}
          )`
      : 'none'};
  border: ${(props) =>
    props.focused
      ? 'none'
      : `${Colors['modal']['button']['border']} ${
          3 * Screen.widthRatio
        }px solid`};
  border-radius: ${40 * Screen.widthRatio}px;
  color: ${(props) =>
    props.focused
      ? `${Colors['modal']['button']['text']}`
      : `${Colors['modal']['button']['border']}`};
  cursor: pointer;
  height: ${80 * Screen.widthRatio}px;
  font-family: ${Fonts['regular']};
  font-size: ${34 * Screen.widthRatio}px;
  margin: 0 ${15 * Screen.widthRatio}px;
  width: ${500 * Screen.widthRatio}px;
  z-index: 1;
`;

export default ModalActivate;
